import { gql } from "@apollo/client"

export const getSkinnyBanner = gql`
  query getSkinnyBannerContent($branchName: String!, $preview: Boolean) {
    getSkinnyBannerContent(branchName: $branchName, preview: $preview) {
      ...SkinnyBannerFragment
      experimentId
      variants {
        ...SkinnyBannerFragment
      }
    }
  }
  fragment SkinnyBannerFragment on SkinnyBanner {
    id
    title
    isMember
    isNonMember
    backgroundColor
    href
    pagesToShow
    pagesToExclude
    smallPrint
    longText
    shortText
    preventWidowsDesktop
    preventWidowsMobile
  }
`

export const getMemberSkinnyBanner = gql`
  query getMemberSkinnyBanner($branchName: String!, $preview: Boolean) {
    getMemberSkinnyBannerContent(branchName: $branchName, preview: $preview) {
      ...SkinnyBannerFragment
      experimentId
      variants {
        ...SkinnyBannerFragment
      }
    }
  }
  fragment SkinnyBannerFragment on SkinnyBanner {
    id
    title
    isMember
    isNonMember
    backgroundColor
    href
    pagesToShow
    pagesToExclude
    smallPrint
    longText
    shortText
    preventWidowsDesktop
    preventWidowsMobile
  }
`
